import { ComponentType } from "react";
import { MaintenanceForwardingStatus } from "../types/forwardings/maintenanceForwarding.type";
import MaintenanceWorkflowActionsOnGoingEstablishmentChoice from "../pages/Show/components/actions/establishmentChoice";

export const maintenanceWorkflowActions: Partial<{
  [K in MaintenanceForwardingStatus]: {
    component: ComponentType;
  }
}> = {
  ongoing_establishment_choice: {
    component: MaintenanceWorkflowActionsOnGoingEstablishmentChoice,
  },
}
